module.exports = __webpack_public_path__ + "media/images/front/amazon_pay_gift-fa7133db61c262db77bdc21b993e1b0f.png";